import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "d-flex flex-wrap ga-4 mt-6" }

import { storeToRefs } from "pinia";
import { useDisplay } from "vuetify";

import { useAccounts } from "@/stores/accounts";
import { useInvitation } from "@/composables";

import PageHeader from "@/components/Common/PageHeader.vue";
import WalletConnectBtn from "@/components/WalletConnect/WalletConnectBtn.vue";
import HowItWorksDialog from "@/components/Dialogs/HowItWorksDialog.vue";

import CardBg from "@/assets/images/connect-wallet-card-bg.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'WalletConnectCard',
  setup(__props) {

const { activeAccount } = storeToRefs(useAccounts());
const { smAndDown } = useDisplay();

const { invitationCode } = useInvitation();

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (!_unref(activeAccount) && !_unref(invitationCode))
    ? (_openBlock(), _createBlock(PageHeader, {
        key: 0,
        class: "wallet-connect-card",
        image: _unref(CardBg)
      }, {
        title: _withCtx(() => [
          _cache[0] || (_cache[0] = _createTextVNode(" 🔌_")),
          _createVNode(_component_i18n_t, { keypath: "blocks.walletConnectCard.title" })
        ]),
        text: _withCtx(() => [
          _createElementVNode("p", {
            textContent: _toDisplayString(_ctx.$t('blocks.walletConnectCard.desc1')),
            class: "text-subtitle-1"
          }, null, 8, _hoisted_1),
          _createElementVNode("p", {
            textContent: _toDisplayString(_ctx.$t('blocks.walletConnectCard.desc2')),
            class: "text-subtitle-1"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(WalletConnectBtn, { block: _unref(smAndDown) }, null, 8, ["block"]),
            _createVNode(HowItWorksDialog)
          ])
        ]),
        _: 1
      }, 8, ["image"]))
    : _createCommentVNode("", true)
}
}

})